// eslint-disable-next-line aveny/mui-import-rule
import NoSsr from '@mui/material/NoSsr';
// eslint-disable-next-line aveny/mui-import-rule
import Stack from '@mui/material/Stack';
import { useItemTooltip, useMouseTracker } from '@mui/x-charts-pro';
import { generateVirtualElement } from '../../../../../Utils/detaljanalysUtils';
import EDPopper from '../../../../../../../../../../BaseComponents/Popper/EDPopper';
import EDTypography from '../../../../../../../../../../BaseComponents/Typography/EDTypography';
import EDBox from '../../../../../../../../../../BaseComponents/EDBox/EDBox';

export function EkonomiskAnalysCustomItemTooltip() {
  const tooltipData = useItemTooltip();
  const mousePosition = useMouseTracker(); // Track the mouse position on chart.

  if (!tooltipData || !mousePosition) {
    // No data to display
    return null;
  }

  // The pointer type can be used to have different behavior based on pointer type.
  const isMousePointer = mousePosition?.pointerType === 'mouse';
  // Adapt the tooltip offset to the size of the pointer.
  const yOffset = isMousePointer ? 0 : 40 - mousePosition.height;

  const subLabelExists =
    typeof tooltipData.value === 'object' &&
    'subLabel' in (tooltipData.value ?? {}) &&
    (tooltipData.value as { subLabel?: string }).subLabel;

  return (
    <NoSsr>
      <EDPopper
        sx={{
          pointerEvents: 'none',
          zIndex: theme => theme.zIndex.modal,
        }}
        open
        placement={isMousePointer ? 'right' : 'right'}
        anchorEl={generateVirtualElement(mousePosition)}
        modifiers={[
          {
            name: 'offset',
            options: {
              offset: [0, yOffset],
            },
          },
        ]}
      >
        <EDBox
          sx={{
            m: 1,
            p: 1.5,
            border: 'solid',
            backgroundColor: 'background.paper',
            borderWidth: 2,
            borderColor: 'divider',
          }}
        >
          <Stack direction="column" alignItems="flex-start">
            <Stack direction="row" alignItems="center">
              <div
                style={{
                  width: 11,
                  height: 11,
                  borderRadius: '50%',
                  backgroundColor: tooltipData.color,
                }}
              />
              <EDTypography sx={{ ml: 2 }}>{tooltipData.label}</EDTypography>
              <EDTypography sx={{ ml: 2 }}>
                {tooltipData.formattedValue}
              </EDTypography>
            </Stack>
            {subLabelExists && (
              <Stack direction="row" alignItems="center">
                <div
                  style={{
                    width: 11,
                    height: 11,
                    backgroundColor: 'transparent',
                  }}
                />
                <EDTypography sx={{ ml: 2 }}>
                  {(tooltipData.value as { subLabel?: string }).subLabel}
                </EDTypography>
              </Stack>
            )}
          </Stack>
        </EDBox>
      </EDPopper>
    </NoSsr>
  );
}
